import * as React from 'react';
import { SVGProps } from 'react';

const IconStopSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 3h10v10H3z" />
  </svg>
);
export default IconStopSizeS;
